export const concat = (xs) => (x) => Array.prototype.concat(xs, x);
